import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';
const initialPage = JSON.parse(window.app.dataset.page);
window.moment = moment;
window.moment.locale(initialPage.props.locale);
Vue.use(vueMoment, {
    moment: window.moment,
});
